var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCreditCardIcon02(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "credit-card-02"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M18.3337 8.83268H1.66699M9.16699 12.166H5.00033M1.66699 7.33268L1.66699 13.666C1.66699 14.5994 1.66699 15.0661 1.84865 15.4227C2.00844 15.7363 2.2634 15.9912 2.57701 16.151C2.93353 16.3327 3.40024 16.3327 4.33366 16.3327L15.667 16.3327C16.6004 16.3327 17.0671 16.3327 17.4236 16.151C17.7372 15.9912 17.9922 15.7363 18.152 15.4227C18.3337 15.0661 18.3337 14.5994 18.3337 13.666V7.33268C18.3337 6.39926 18.3337 5.93255 18.152 5.57603C17.9922 5.26243 17.7372 5.00746 17.4236 4.84767C17.0671 4.66602 16.6004 4.66602 15.667 4.66602L4.33366 4.66602C3.40024 4.66602 2.93353 4.66602 2.57701 4.84767C2.2634 5.00746 2.00844 5.26243 1.84865 5.57603C1.66699 5.93255 1.66699 6.39926 1.66699 7.33268Z",
    stroke: "#98A2B3",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditCardIcon02);
export default __webpack_public_path__ + "static/media/creditCardIcon02.de0ad78dfd9d8dd25c406d38e3d88e88.svg";
export { ForwardRef as ReactComponent };